import { portalLogout, portalLogin, portalProfile } from '@/api/portal'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    userId: '',
    nickName: '',
    roles: [],
    dept: {},
    ssoControl: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICK_NAME: (state, nickName) => {
      state.nickName = nickName
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_DEPT: (state, dept) => {
      state.dept = dept
    },
    SET_SSO_CONTROL: (state, ssoControl) => {
      state.ssoControl = ssoControl
    },
    SET_AUTHORIZATION(state, actived) {
      state.authorization = actived
    }
  },

  actions: {
    SetAuthorization({ commit }, actived) {
      setToken(actived)
      commit('SET_AUTHORIZATION', actived)
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        portalLogin(userInfo).then(res => {
          localStorage.setItem('username', userInfo.username)
          setToken(res.data)
          commit('SET_TOKEN', res.data)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        portalProfile(state.token).then(res => {
          const data = res.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', data.userName)
          commit('SET_NICK_NAME', data.nickName)
          commit('SET_USER_ID', data.userId)
          commit('SET_DEPT', data.dept)
          localStorage.setItem('userId', data.userId)
          localStorage.setItem('roles', JSON.stringify(data.roles))
          localStorage.setItem('userInfo', JSON.stringify(data))
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        portalLogout().then((res) => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
